import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const PlanVersion: ITypeSpecificPolicy<types.PlanVersion> = {
  fields: {
    createdTimestamp: dateTimeFieldPolicy(),
    updatedTimestamp: dateTimeFieldPolicy()
  }
};
